import { render, staticRenderFns } from "./TransactionCreate.vue?vue&type=template&id=1bd75946"
import script from "./TransactionCreate.vue?vue&type=script&lang=js"
export * from "./TransactionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports